import { useState, useEffect } from 'react';

// @material-ui core components
import IconButton from '@mui/material/IconButton';
import Icon from '@mui/material/Icon';

// Otis Admin PRO React context
import { useMaterialUIController, setMiniSidenav } from 'context';

export const HamburgerButton = () => {
  const [controller, dispatch] = useMaterialUIController();
  const { miniSidenav } = controller;

  const handleMiniSidenav = () => {
    setMiniSidenav(dispatch, !miniSidenav);
  };

  const iconsStyle = ({ palette: { hamburger }, functions: { rgba } }) => ({
    color: () => {
      return hamburger.main;
    },
  });

  return (
    <IconButton onClick={handleMiniSidenav} size="large" disableRipple>
      <Icon fontSize="large" sx={iconsStyle}>
        {miniSidenav ? 'menu' : 'menu_open'}
      </Icon>
    </IconButton>
  );
};
